import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio, FormControlLabel } from '@material-ui/core';
import { compliance } from '../CreateReport';
import { useStyles } from './Checkbox.styles';

interface IProps {
  type: compliance;
  value: compliance | undefined;
  hidden?: boolean;
  style?: React.CSSProperties;
  labelKey?: string;
}

export const ComplianceReportCheckbox: FC<IProps> = ({ type, value, hidden, style, labelKey }) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      value="top"
      control={
        <Radio
          disabled={hidden}
          className={classes[type]}
          classes={{ checked: classes[type] }}
          color="default"
          checked={value === type}
          value={type}
          style={style||{}}
        />
      }
      label={<FormattedMessage id={labelKey ?? `law-portal.compliance.question.compliance.${type}.label`} />}
      labelPlacement="top"
    />
  );
};
